import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/ofp`;

export const ofpService = {
  getStatus: async () => {
    const response = await axios.get(`${API_BASE}/status`);
    return response.data;
  },

  getOrganizations: async () => {
    const response = await axios.get(`${API_BASE}/organizations`);
    return response.data;
  },

  getFacilities: async (organizationId = null) => {
    const params = organizationId ? { organization_id: organizationId } : {};
    const response = await axios.get(`${API_BASE}/facilities`, { params });
    return response.data;
  },

  validateEntity: async (entityType, entityId) => {
    const response = await axios.get(`${API_BASE}/validate/entity/${entityType}/${entityId}`);
    return response.data;
  },

  validateReference: async (fieldName, referenceId) => {
    const response = await axios.get(`${API_BASE}/validate/reference/${fieldName}/${referenceId}`);
    return response.data;
  },

  validateReferences: async (references) => {
    const response = await axios.post(`${API_BASE}/validate/references`, references);
    return response.data;
  },

  getEntityDetails: async (entityType, entityId) => {
    const response = await axios.get(`${API_BASE}/entity/${entityType}/${entityId}`);
    return response.data;
  }
};

export default ofpService;
